import { Product } from '../domain/Product'
import { ProductListScreenData } from '../domain/ProductListScreenData'
import { ProductRepository, ProductConfigurationRepository } from '../domain/ProductRepository'
import { Tax } from '../domain/Invoiceable'
import { FileRepository } from '@/modules/shared/domain/FileRepository'
import { JobRepository } from '@/modules/jobs/domain/JobRepository'
import { DEFAULT_HEADERS } from '../infra/VueProductListScreenData'

export class ProductListComponent {

    product_repo: ProductRepository
    file_repo: FileRepository
    jobs_repo:JobRepository
    screen_data: ProductListScreenData
    product_config_repo: ProductConfigurationRepository

    constructor(product_repo, jobs_repo, file_repo, screen_data, product_config_repo) {
        this.product_repo = product_repo
        this.screen_data = screen_data
        this.file_repo = file_repo
        this.jobs_repo = jobs_repo
        this.product_config_repo = product_config_repo
    }

    async updateProductList(company_id: Number, filters:any) {
        this.screen_data.setLoading(true)
        let res = await this.product_repo.getProductList(parseInt(company_id.toString()), filters)
        this.screen_data.setProducts(res)
        this.screen_data.setTotalItems(res.length)
        this.screen_data.setLoading(false)
        this.screen_data.dirty = []
        this.screen_data.selectedItems = []
    }

    async uploadProductConfiguration(company_id: Number) {
        let config = await this.product_config_repo.get_by_company(company_id)
        this.screen_data.setProductConfiguration(config)
        this.screen_data.products_headers = DEFAULT_HEADERS.slice() // reset to default headers
        if (this.screen_data.productConfiguration && this.screen_data.productConfiguration.fields) {
            this.screen_data.productConfiguration.fields.forEach(field => {
               this.screen_data.products_headers.splice(this.screen_data.products_headers.length - 1, 0, { text: field.name, value: field.key, sortable: false, width: '75px' });
            });
        }
        this.createEmptyProduct(company_id);
    }

    createEmptyProduct(company_id: Number) {
        let product = this.product_repo.create_empty_product(company_id, this.screen_data.productConfiguration)
        this.screen_data.setProduct(product)
    }

    async saveProductConfiguration(company_id: Number, config: any) {
        try {
            let res = await this.product_config_repo.save(config)
            if (res && res['status'] == 'success') {
                this.screen_data.success_message('Configuración guardada correctamente')
                return true
            } else {
                this.screen_data.error_message('Error al guardar la configuración')
                return false
            }
        } catch (error) {
            this.screen_data.error_message('Error al guardar la configuración')
            return false
        }
    }

    updateTableLimit(value) {
        this.screen_data.changeLimit(value)
    }

    updateTaxes(product_to_update) {
        let product = product_to_update
        product.taxes[0] = new Tax(product.selected_tax, product.price, product.selected_tax*product.price)
        if (product.selected_retention == 'na') {
            product.taxes_withheld = []
        } else {
            let rate = parseFloat(product.selected_retention)
            product.taxes_withheld = [new Tax(rate, product.price, product.price*rate)]
        }
        let reason = ''
        if (product.selected_tax == 0.0 && product.selected_tax_event){
            if (product.selected_tax_event == 'ISP'){
                reason = 'Inversión del sujeto pasivo en virtud del art 84.Uno de la Ley 37/1992, del IVA'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else if (product.selected_tax_event == 'NS'){
                reason  = 'Operación no sujeta a IVA en virtud del art. 7 de la Ley 37/1992, del IVA'
                product.special_taxable_event = {code:'02', reason:reason}
            }
            else if (product.selected_tax_event == 'EX'){
                reason = 'Operación exenta en virtud del art. 20 de la Ley 37/1992, del IVA'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else if(product.selected_tax_event == 'INTRA.'){
                reason = 'Entrega intracomunitaria exenta en virtud del art. 25 de la Ley 37/1992, del IVA'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else if(product.selected_tax_event == 'EXPORT.'){
                reason = 'Operación exenta por exportación en virtud del art. 21 de la Ley 37/1992, del IVA'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else if(product.selected_tax_event == 'Art. 50'){
                reason = 'Operación exenta de IGIC en virtud del Art. 50 de la Ley 4/2012.'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else if(product.selected_tax_event == 'Art. 11'){
                reason = 'Operación exenta de IGIC en virtud del Art. 11 de la Ley 20/1991.'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else if(product.selected_tax_event == 'Art. 12'){
                reason = 'Operación exenta de IGIC en virtud del Art. 12 de la Ley 20/1991.'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else if(product.selected_tax_event == 'Art. 13'){
                reason = 'Operación exenta de IGIC en virtud del Art. 13 de la Ley 20/1991.'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else if(product.selected_tax_event == 'Art. 25'){
                reason = 'Operación exenta de IGIC en virtud del Art. 25 de la Ley 19/1994.'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else if(product.selected_tax_event == 'Art. 47'){
                reason = 'Operación exenta de IGIC en virtud del Art. 47 de la Ley 19/1994.'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else if(product.selected_tax_event == 'Art. 110'){
                reason = 'Operación exenta de IGIC en virtud del Art. 110 de la Ley 4/2012.'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else if(product.selected_tax_event == 'Otros'){
                reason = 'Operación exenta de IGIC.'
                product.special_taxable_event = {code:'01', reason:reason}
            }
            else{
                product.special_taxable_event = null
            }
        }
    }

    async save(product_to_save: Product): Promise<boolean> {
        this.screen_data.setLoadingAddProduct(true)
        this.screen_data.changeLoadingProduct(product_to_save.id, true)
        let res = await this.product_repo.save(product_to_save)
        this.screen_data.setLoadingAddProduct(false)
        this.screen_data.changeLoadingProduct(product_to_save.id, false)
        if (res && res['status'] == 'success') {
            this.screen_data.success_message('Producto guardado correctamente')
            this.screen_data.removeDirty(product_to_save.id)
            let product = this.product_repo.create_empty_product(this.screen_data.product.company_id, this.screen_data.productConfiguration)
            this.screen_data.setProduct(product)
            return true
        } else {
            if (res['message'] == 'Product code already exists') {
                this.screen_data.error_message('El código de producto ya existe')
            }
            else if (res['message'] == 'Product code cannot be empty') {
                this.screen_data.error_message('El código de producto no puede estar vacío')
            }
            else if (res['message'] == 'Product description cannot be empty') {
                this.screen_data.error_message('La descripcion del producto no puede estar vacía')
            }
            else {
                this.screen_data.error_message('Error al guardar el producto')
            }
            return false
        }
    }

    async delete(products: Product[]) {
        this.screen_data.setLoadingDeleteProduct(true)
        let res = await this.product_repo.delete(products)
        this.screen_data.setLoadingDeleteProduct(false)
        if (res && res['status'] =='success') {
            this.screen_data.success_message('Productos eliminados correctamente')
            this.screen_data.product = this.product_repo.create_empty_product(this.screen_data.product.company_id, this.screen_data.productConfiguration)
        } else {
            this.screen_data.error_message('Error al eliminar los productos')
        }
    }

    async uploadProductsDone(company_id, filters){
        let job = await this.jobs_repo.find_by_id(this.screen_data.uploadProductsJobId)        
        this.screen_data.setUploadProductsJobState(job.state);
        if (this.screen_data.uploadProductsJobState == 'done') {            
            this.updateProductList(company_id, filters)
        }        
        this.screen_data.setLoadingUploadProducts(false);                
    }

    async uploadProductsExcel(company_id, file) {
        this.screen_data.setLoadingUploadProducts(true)
        try {
            let file_path = await this.file_repo.uploadFile(file)
            let result = await this.product_repo.upload_products_file(company_id, file_path, file.name)
            this.screen_data.dialogUploadProducts = false

            if (result && result.status === 'success') {
                this.screen_data.clearImportErrors()
                this.screen_data.success_message(`Productos importados correctamente: ${result.saved_count} producto(s) guardado(s)`)
                // Refresh the product list to show the newly imported products
                await this.updateProductList(company_id, {})
            } else if (result && result.status === 'error') {
                // Store errors for display in dialog
                let errors = []

                // If there are detailed errors, process them
                if (result.errors && Array.isArray(result.errors)) {
                    errors = result.errors.map(err => {
                        // If error is an object, stringify it for later parsing
                        if (typeof err === 'object') {
                            return JSON.stringify(err)
                        }
                        return err
                    })
                } else if (result.errors && typeof result.errors === 'object') {
                    errors = Object.values(result.errors).flat().map(err => {
                        if (typeof err === 'object') {
                            return JSON.stringify(err)
                        }
                        return err
                    })
                }

                // If no detailed errors, use the general error message
                if (errors.length === 0) {
                    let errorMsg = result.error_message || 'Error al importar productos'
                    errors = [errorMsg]
                }

                this.screen_data.setImportErrors(errors)
                this.screen_data.error_message('Error al importar productos. Haz clic en el botón de errores para ver los detalles.')
            } else {
                this.screen_data.setImportErrors(['Error inesperado al importar productos'])
                this.screen_data.error_message('Error inesperado al importar productos')
            }
        } catch (error) {
            console.error('Error uploading products:', error)
            this.screen_data.setImportErrors(['Error al procesar el archivo. Por favor, verifique el formato e inténtelo de nuevo.'])
            this.screen_data.error_message('Error al procesar el archivo. Por favor, verifique el formato e inténtelo de nuevo.')
        } finally {
            this.screen_data.setLoadingUploadProducts(false)
        }
    }
}